import React from 'react';
import cn from 'classnames';
import { roundChartValue } from '@/creditflowresearch/ui/components/bonds/Charts/helpers';
import { IChartTooltipData } from '@/creditflowresearch/domain/vo/Bond/IChartTooltipData';

import styles from '@/creditflowresearch/ui/common/components/MarketChart/chartTooltip.module.scss';

interface IProps {
  item: IChartTooltipData,
  withPercent: boolean,
}

const RowTooltip = ({ item, withPercent }: IProps) => (
  <div className={ cn(styles.item, styles.itemStacked) }>
    <div className={ styles.itemName }>
      <span
        className={ styles.itemSquare }
        style={ { backgroundColor: item.color } }
      />
      { item.name }
    </div>
    <div className={ cn(styles.itemDealCount) }>
      { item.dealCount.toLocaleString('en-US') }
    </div>
    <div className={ styles.itemDealSize }>
      ${ roundChartValue(item.dealSize) }
    </div>
    { withPercent && (
      <div className={ styles.itemPercent }>
        { item.percentage.toFixed(1) }%
      </div>
    ) }
  </div>
);

export default RowTooltip;
